module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-online date-2000px.11985ee.jpg";